import Identification from './Identification'

Vue.prototype.$state.$identifications = new Vue(Identification)

Vue.component('identifications-editor', () => import(/* webpackChunkName: "identifications-editor" */ '@modulesPages/Identification/Resources/assets/js/Components/IdentificationsEditor'))

app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Identification\\Entities\\Identification': 'Identification',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Identification\\Entities\\Identification': 'identificationss',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'identificationss': 'Modules\\Identification\\Entities\\Identification',
	}	
}